import { useIntl } from "react-intl";
import { DetailsField } from "components/DetailsField";
import { HistoryDetailsMerkAccountProps } from "./types";
import { messages } from "./messages";
import { useFormatter } from "hooks/utils/useFormatter";

export const HistoryDetailsMerkAccount: React.FC<
  HistoryDetailsMerkAccountProps
> = ({ data: movement }) => {
  const { formatMessage } = useIntl();
  const { formatValue } = useFormatter();

  return (
    <div className="flex flex-col gap-y-6 pdf:p-10">
      <DetailsField
        label={formatMessage(messages.merkAmount)}
        value={
          formatValue(movement.amount, movement.precision) +
          " " +
          movement.ticker_id.toUpperCase()
        }
      />
      <DetailsField
        label={formatMessage(messages.movementId)}
        value={movement.tid ?? ""}
        copy
      />
    </div>
  );
};
